// Games category step images

import chessOpeningsCh1S1 from '@/assets/step-images/chess-openings-ch1-s1.jpg';
import chessOpeningsCh1S2 from '@/assets/step-images/chess-openings-ch1-s2.jpg';
import chessOpeningsCh1S3 from '@/assets/step-images/chess-openings-ch1-s3.jpg';
import chessOpeningsCh1S4 from '@/assets/step-images/chess-openings-ch1-s4.jpg';
import chessOpeningsCh1S5 from '@/assets/step-images/chess-openings-ch1-s5.jpg';
import chessOpeningsCh2S1 from '@/assets/step-images/chess-openings-ch2-s1.jpg';
import chessOpeningsCh2S2 from '@/assets/step-images/chess-openings-ch2-s2.jpg';
import chessOpeningsCh2S3 from '@/assets/step-images/chess-openings-ch2-s3.jpg';
import chessOpeningsCh2S4 from '@/assets/step-images/chess-openings-ch2-s4.jpg';
import chessOpeningsCh2S5 from '@/assets/step-images/chess-openings-ch2-s5.jpg';
import chessOpeningsCh3S1 from '@/assets/step-images/chess-openings-ch3-s1.jpg';
import chessOpeningsCh3S2 from '@/assets/step-images/chess-openings-ch3-s2.jpg';
import chessOpeningsCh3S3 from '@/assets/step-images/chess-openings-ch3-s3.jpg';
import chessOpeningsCh3S4 from '@/assets/step-images/chess-openings-ch3-s4.jpg';
import chessOpeningsCh3S5 from '@/assets/step-images/chess-openings-ch3-s5.jpg';

import learnChessCh1S1 from '@/assets/step-images/learn-chess-ch1-s1.jpg';
import learnChessCh1S2 from '@/assets/step-images/learn-chess-ch1-s2.jpg';
import learnChessCh1S3 from '@/assets/step-images/learn-chess-ch1-s3.jpg';
import learnChessCh1S4 from '@/assets/step-images/learn-chess-ch1-s4.jpg';
import learnChessCh1S5 from '@/assets/step-images/learn-chess-ch1-s5.jpg';
import learnChessCh2S1 from '@/assets/step-images/learn-chess-ch2-s1.jpg';
import learnChessCh2S2 from '@/assets/step-images/learn-chess-ch2-s2.jpg';

import ltcgCh1S1 from '@/assets/step-images/learn-three-card-games-ch1-s1.jpg';
import ltcgCh1S2 from '@/assets/step-images/learn-three-card-games-ch1-s2.jpg';
import ltcgCh1S3 from '@/assets/step-images/learn-three-card-games-ch1-s3.jpg';
import ltcgCh1S4 from '@/assets/step-images/learn-three-card-games-ch1-s4.jpg';
import ltcgCh1S5 from '@/assets/step-images/learn-three-card-games-ch1-s5.jpg';
import ltcgCh2S1 from '@/assets/step-images/learn-three-card-games-ch2-s1.jpg';
import ltcgCh2S2 from '@/assets/step-images/learn-three-card-games-ch2-s2.jpg';
import ltcgCh2S3 from '@/assets/step-images/learn-three-card-games-ch2-s3.jpg';
import ltcgCh2S4 from '@/assets/step-images/learn-three-card-games-ch2-s4.jpg';
import ltcgCh2S5 from '@/assets/step-images/learn-three-card-games-ch2-s5.jpg';
import ltcgCh3S1 from '@/assets/step-images/learn-three-card-games-ch3-s1.jpg';
import ltcgCh3S2 from '@/assets/step-images/learn-three-card-games-ch3-s2.jpg';
import ltcgCh3S3 from '@/assets/step-images/learn-three-card-games-ch3-s3.jpg';
import ltcgCh3S4 from '@/assets/step-images/learn-three-card-games-ch3-s4.jpg';
import ltcgCh3S5 from '@/assets/step-images/learn-three-card-games-ch3-s5.jpg';

import murderMysteryCh1S1 from '@/assets/step-images/murder-mystery-ch1-s1.jpg';
import murderMysteryCh1S2 from '@/assets/step-images/murder-mystery-ch1-s2.jpg';
import murderMysteryCh1S3 from '@/assets/step-images/murder-mystery-ch1-s3.jpg';
import murderMysteryCh1S4 from '@/assets/step-images/murder-mystery-ch1-s4.jpg';
import murderMysteryCh1S5 from '@/assets/step-images/murder-mystery-ch1-s5.jpg';
import murderMysteryCh2S1 from '@/assets/step-images/murder-mystery-ch2-s1.jpg';
import murderMysteryCh2S2 from '@/assets/step-images/murder-mystery-ch2-s2.jpg';
import murderMysteryCh2S3 from '@/assets/step-images/murder-mystery-ch2-s3.jpg';
import murderMysteryCh2S4 from '@/assets/step-images/murder-mystery-ch2-s4.jpg';
import murderMysteryCh2S5 from '@/assets/step-images/murder-mystery-ch2-s5.jpg';
import murderMysteryCh3S1 from '@/assets/step-images/murder-mystery-ch3-s1.jpg';
import murderMysteryCh3S2 from '@/assets/step-images/murder-mystery-ch3-s2.jpg';
import murderMysteryCh3S3 from '@/assets/step-images/murder-mystery-ch3-s3.jpg';
import murderMysteryCh3S4 from '@/assets/step-images/murder-mystery-ch3-s4.jpg';
import murderMysteryCh3S5 from '@/assets/step-images/murder-mystery-ch3-s5.jpg';

import triviaNightCh1S1 from '@/assets/step-images/trivia-night-ch1-s1.jpg';
import triviaNightCh1S2 from '@/assets/step-images/trivia-night-ch1-s2.jpg';
import triviaNightCh1S3 from '@/assets/step-images/trivia-night-ch1-s3.jpg';
import triviaNightCh1S4 from '@/assets/step-images/trivia-night-ch1-s4.jpg';
import triviaNightCh1S5 from '@/assets/step-images/trivia-night-ch1-s5.jpg';
import triviaNightCh2S1 from '@/assets/step-images/trivia-night-ch2-s1.jpg';
import triviaNightCh2S2 from '@/assets/step-images/trivia-night-ch2-s2.jpg';
import triviaNightCh2S3 from '@/assets/step-images/trivia-night-ch2-s3.jpg';
import triviaNightCh2S4 from '@/assets/step-images/trivia-night-ch2-s4.jpg';
import triviaNightCh2S5 from '@/assets/step-images/trivia-night-ch2-s5.jpg';
import triviaNightCh3S1 from '@/assets/step-images/trivia-night-ch3-s1.jpg';
import triviaNightCh3S2 from '@/assets/step-images/trivia-night-ch3-s2.jpg';
import triviaNightCh3S3 from '@/assets/step-images/trivia-night-ch3-s3.jpg';
import triviaNightCh3S4 from '@/assets/step-images/trivia-night-ch3-s4.jpg';
import triviaNightCh3S5 from '@/assets/step-images/trivia-night-ch3-s5.jpg';

export const GAMES_IMAGES: Record<string, string> = {
  'chess-openings-ch1-s1': chessOpeningsCh1S1,
  'chess-openings-ch1-s2': chessOpeningsCh1S2,
  'chess-openings-ch1-s3': chessOpeningsCh1S3,
  'chess-openings-ch1-s4': chessOpeningsCh1S4,
  'chess-openings-ch1-s5': chessOpeningsCh1S5,
  'chess-openings-ch2-s1': chessOpeningsCh2S1,
  'chess-openings-ch2-s2': chessOpeningsCh2S2,
  'chess-openings-ch2-s3': chessOpeningsCh2S3,
  'chess-openings-ch2-s4': chessOpeningsCh2S4,
  'chess-openings-ch2-s5': chessOpeningsCh2S5,
  'chess-openings-ch3-s1': chessOpeningsCh3S1,
  'chess-openings-ch3-s2': chessOpeningsCh3S2,
  'chess-openings-ch3-s3': chessOpeningsCh3S3,
  'chess-openings-ch3-s4': chessOpeningsCh3S4,
  'chess-openings-ch3-s5': chessOpeningsCh3S5,
  'learn-chess-ch1-s1': learnChessCh1S1,
  'learn-chess-ch1-s2': learnChessCh1S2,
  'learn-chess-ch1-s3': learnChessCh1S3,
  'learn-chess-ch1-s4': learnChessCh1S4,
  'learn-chess-ch1-s5': learnChessCh1S5,
  'learn-chess-ch2-s1': learnChessCh2S1,
  'learn-chess-ch2-s2': learnChessCh2S2,
  'learn-three-card-games-ch1-s1': ltcgCh1S1,
  'learn-three-card-games-ch1-s2': ltcgCh1S2,
  'learn-three-card-games-ch1-s3': ltcgCh1S3,
  'learn-three-card-games-ch1-s4': ltcgCh1S4,
  'learn-three-card-games-ch1-s5': ltcgCh1S5,
  'learn-three-card-games-ch2-s1': ltcgCh2S1,
  'learn-three-card-games-ch2-s2': ltcgCh2S2,
  'learn-three-card-games-ch2-s3': ltcgCh2S3,
  'learn-three-card-games-ch2-s4': ltcgCh2S4,
  'learn-three-card-games-ch2-s5': ltcgCh2S5,
  'learn-three-card-games-ch3-s1': ltcgCh3S1,
  'learn-three-card-games-ch3-s2': ltcgCh3S2,
  'learn-three-card-games-ch3-s3': ltcgCh3S3,
  'learn-three-card-games-ch3-s4': ltcgCh3S4,
  'learn-three-card-games-ch3-s5': ltcgCh3S5,
  'murder-mystery-ch1-s1': murderMysteryCh1S1,
  'murder-mystery-ch1-s2': murderMysteryCh1S2,
  'murder-mystery-ch1-s3': murderMysteryCh1S3,
  'murder-mystery-ch1-s4': murderMysteryCh1S4,
  'murder-mystery-ch1-s5': murderMysteryCh1S5,
  'murder-mystery-ch2-s1': murderMysteryCh2S1,
  'murder-mystery-ch2-s2': murderMysteryCh2S2,
  'murder-mystery-ch2-s3': murderMysteryCh2S3,
  'murder-mystery-ch2-s4': murderMysteryCh2S4,
  'murder-mystery-ch2-s5': murderMysteryCh2S5,
  'murder-mystery-ch3-s1': murderMysteryCh3S1,
  'murder-mystery-ch3-s2': murderMysteryCh3S2,
  'murder-mystery-ch3-s3': murderMysteryCh3S3,
  'murder-mystery-ch3-s4': murderMysteryCh3S4,
  'murder-mystery-ch3-s5': murderMysteryCh3S5,
  'trivia-night-ch1-s1': triviaNightCh1S1,
  'trivia-night-ch1-s2': triviaNightCh1S2,
  'trivia-night-ch1-s3': triviaNightCh1S3,
  'trivia-night-ch1-s4': triviaNightCh1S4,
  'trivia-night-ch1-s5': triviaNightCh1S5,
  'trivia-night-ch2-s1': triviaNightCh2S1,
  'trivia-night-ch2-s2': triviaNightCh2S2,
  'trivia-night-ch2-s3': triviaNightCh2S3,
  'trivia-night-ch2-s4': triviaNightCh2S4,
  'trivia-night-ch2-s5': triviaNightCh2S5,
  'trivia-night-ch3-s1': triviaNightCh3S1,
  'trivia-night-ch3-s2': triviaNightCh3S2,
  'trivia-night-ch3-s3': triviaNightCh3S3,
  'trivia-night-ch3-s4': triviaNightCh3S4,
  'trivia-night-ch3-s5': triviaNightCh3S5,
};
